// Shared var storage for state

const appState = {
  isAnimating: false,
  navOpen: false,
  navStuck: false
};

export default appState
